'use strict'

require('picturefill')
require('intersection-observer')

// import { Budoux } from './lib/Budoux'
import { ShowPagetop } from './lib/ShowPagetop'
import { Smooth } from './lib/Smooth'
import { TelGrant } from './lib/TelGrant'
import { EqualHeight } from './lib/EqualHeight'
import { Drawer } from './lib/Drawer'
import { Svg } from './lib/Svg'
import { ScrollAnimation } from './lib/ScrollAnimation'
import { IeModal } from './lib/IeModal'
import { WindowStatus } from './lib/WindowStatus'
import { ViewportHeight } from './lib/ViewportHeight'
import { Zipcode } from './lib/Zipcode'
import { IndexBnrSlider } from './lib/IndexBnrSlider'
import { IndexFeaturesSlider } from './lib/IndexFeaturesSlider'
import { IndexInterviewSlider } from './lib/IndexInterviewSlider'
import { IndexGallerySlider } from './lib/IndexGallerySlider'
import { IndexOtherSlider } from './lib/IndexOtherSlider'
import { hoverMovie } from './lib/hoverMovie'
import { Accordion } from './lib/Accordion'
import { MegaMenu } from './lib/MegaMenu'
import { TextSplit } from './lib/TextSplit'
import { hoverGallery } from './lib/hoverGallery'
import { Loading } from './lib/Loading'
import { Header } from './lib/Header'
import { CourseFeatureSlider } from './lib/CourseFeatureSlider'
import { Tab } from './lib/Tab'
import { CourseInstaSlider } from './lib/CourseInstaSlider'
import { Anchor } from './lib/Anchor'
import { FacilityCardSlider } from './lib/FacilityCardSlider'
import { PostSlider01 } from './lib/PostSlider01'
import { Pallax } from './lib/Pallax'
import { OpencampusKV } from './lib/OpencampusKV'
import { CoursePickupSlider } from './lib/CoursePickupSlider'
import { EventReportSlider } from './lib/EventReportSlider'
import { FormOther } from './lib/FormOther'
import { FormEntry } from './lib/FormEntry'
import { FormDisplay } from './lib/FormDisplay'
import { InterviewKvSlider } from './lib/InterviewKvSlider'
import { InterviewLowerKv } from './lib/InterviewLowerKv'
import { InterviewLowerLink } from './lib/InterviewLowerLink'
import { Modal } from './lib/Modal'
import { OpencampusSchedule } from './lib/OpencampusSchedule'

// new Budoux()
new IeModal('京都文教短期大学', 'サイトURL')
new WindowStatus()
new ViewportHeight()
new Svg()
new ScrollAnimation()
new Drawer()
new ShowPagetop()
new Smooth()
new EqualHeight('.js-max_height')
new TelGrant()
new Zipcode()
new IndexBnrSlider()
new IndexFeaturesSlider()
new IndexInterviewSlider()
new IndexGallerySlider()
new IndexOtherSlider()
new hoverMovie()
new Accordion()
new MegaMenu()
new TextSplit()
new hoverGallery()
new Loading()
new Header()
new CourseFeatureSlider()
new Tab()
new CourseInstaSlider()
new Anchor()
new FacilityCardSlider()
new PostSlider01()
new Pallax()
new OpencampusKV()
new CoursePickupSlider()
new EventReportSlider()
new FormOther()
new FormEntry()
new FormDisplay()
new InterviewKvSlider()
new InterviewLowerKv()
new InterviewLowerLink()
new Modal()
new OpencampusSchedule()
